import React, { ReactNode } from 'react';
import { ConfigLabel, Icon, LabelAlert } from './Alert.styled';

export interface AlertProps {
  label?: string | ReactNode;
  renderValue?: ReactNode;
  children?: ReactNode;
  icon?: 'exclamation-circle' | string;
  status?: 'success' | 'warning' | 'error' | 'neutral' | 'info';
  className?: string;
  fullWidth?: boolean;
  hideIcon?: boolean;
}

export function Alert({
  label,
  renderValue,
  icon = 'exclamation-circle',
  status = 'success',
  children,
  hideIcon,
  ...props
}: AlertProps) {
  return (
    <LabelAlert status={status} className="mt-alert" {...props}>
      {!hideIcon ? <Icon status={status} type={icon} data-testid="alert-icon" /> : null}
      {renderValue}
      {!renderValue && <ConfigLabel>{label || children}</ConfigLabel>}
    </LabelAlert>
  );
}
